// src/pages/OtpPage.jsx
import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import { AuthContext } from "../context/AuthContext"; // ★  use the context

const OtpPage = () => {
	const navigate = useNavigate();
	const { login } = useContext(AuthContext); // ★  get the login helper

	const [otp, setOtp] = useState("");
	const [loading, setLoading] = useState(false);
	const email = localStorage.getItem("email"); // e‑mail was saved during step‑1 login

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);

		const tempToken = sessionStorage.getItem("token"); // token issued in step‑1 login

		try {
			const { data } = await axios.post(
				"https://parallex.approot.ng/otp.php",
				{ otp },
				{
					headers: { Authorization: `Bearer ${tempToken}` },
					// withCredentials: true,
				}
			);

			if (data.status) {
				/* ------------------------------------------------------------ */
				/*  OTP verified → call the context's login() helper            */
				/* ------------------------------------------------------------ */
				login(data.token, data.role, email); // ★  sets token, role, email, login_time

				toast.success("OTP verified!");
				navigate("/dashboard");
			} else {
				// API returned status:false
				const msg = data.message || "Invalid OTP.";
				toast.error(msg);
				localStorage.clear();
				sessionStorage.clear();
				navigate("/");

				if (msg.toLowerCase().includes("otp has expired")) {
					toast.info("Your OTP has expired. Please log in again.");
					/* clean up temp data */
					localStorage.removeItem("email");
					sessionStorage.removeItem("token");
					navigate("/");
				}
			}
		} catch (err) {
			console.error("OTP verification error:", err);
			toast.error("Verification failed. Please try again.");
		} finally {
			setLoading(false);
		}
	};

	/* -------------------------------------------------------------- */
	/*  Guard: if already logged in (token in localStorage)           */
	/* -------------------------------------------------------------- */
	useEffect(() => {
		if (localStorage.getItem("token")) {
			navigate("/dashboard", { replace: true });
		}
		if (!email) {
			navigate("/", { replace: true });
		}
	}, [navigate, email]);

	return (
		<div className='min-h-screen flex items-center justify-center bg-gray-100 font-inter'>
			<div className='bg-white p-8 rounded-2xl shadow-lg w-full max-w-md'>
				<h2 className='text-3xl font-extrabold text-center mb-6 text-red-600'>
					Verify OTP
				</h2>

				<form onSubmit={handleSubmit} className='space-y-6'>
					<p className='text-base text-gray-700 text-center'>
						An OTP was sent to{" "}
						<strong className='text-red-600'>{email || "your email"}</strong>.
						It will expire in 5&nbsp;minutes.
					</p>

					<div>
						<label htmlFor='otp' className='sr-only'>
							Enter OTP
						</label>
						<input
							id='otp'
							type='text'
							value={otp}
							onChange={(e) => setOtp(e.target.value)}
							placeholder='Enter OTP'
							className='w-full px-5 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-3 focus:ring-red-500 transition duration-200 ease-in-out text-lg'
							required
							maxLength='6'
							pattern='\d{6}'
							title='Please enter a 6‑digit OTP'
						/>
					</div>

					<button
						type='submit'
						disabled={loading}
						className='w-full py-3 bg-red-600 text-white font-bold rounded-lg hover:bg-red-700 focus:outline-none focus:ring-3 focus:ring-red-500 transition duration-200 ease-in-out transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed'
					>
						{loading ? "Verifying…" : "Verify OTP"}
					</button>
				</form>
			</div>
		</div>
	);
};

export default OtpPage;
